import React from "react";
import RecipientList from "./RecipientList";

function SignerListPlace(props) {
  return (
    <div className="mb-0 overflow-visible">
      {/* <div className="mx-4 py-2 text-md text-base-content font-semibold">
        <span className="relative">
          {props.title ? props.title : "Recipients"}
        </span>
      </div>
      <hr /> */}
      <div className="overflow-visible hide-scrollbar max-h-[180px] max-w-[300px]">
        <RecipientList {...props} onClearRecipientWidgets={props.onClearRecipientWidgets} />
      </div>
    </div>
  );
}

export default SignerListPlace;
